import * as ProfileAction from './profile.actions';
import {Profile} from '../profile.model';

export interface State {
  audits: any;
  audit: Profile;
  chartReload: string,
  profileDetail: any;
  profileProgress: any;
  audienceStat: any;
  followerStat: any;
  followerEngage: any;
  followerEngageIndicator: any,
  mediaStat: any;
  mediaAnalyze: any;
  mediaCommentAnalyze: any;
  audienceInterest: any;
  audienceLocation: any;
  score: any;
  userRank: any;
  loader: any;
  autoload: boolean;
  profileMedia: any[];
  boxExampleStatus: any;
  auditId: number;
  audienceTiktok: any;
}

export const initialState: State = {
  auditId: 0,
  audits: [],
  audit: null,
  chartReload: '',
  profileDetail: null,
  profileProgress: null,
  audienceStat: null,
  followerStat: null,
  followerEngage: null,
  followerEngageIndicator: null,
  mediaStat: null,
  mediaAnalyze: null,
  mediaCommentAnalyze: null,
  audienceInterest: null,
  audienceLocation: null,
  score: null,
  userRank: [],
  loader: {
    auditList: {
      list: true
    },
    audit: {
      detail: true,
      media: true,
      engageIndicator: true,
      followerStat: true,
      mediaStat: true,
      audienceStat: true,
      mediaCommentAnalyze: true,
      audienceLocation: true,
      mediaAnalyze: true,
      followerEngage: true,
      userRank: true
    },
    auditAdd: {
      add: true
    },
    compare: {
      generate: true
    }
  },
  autoload: false,
  profileMedia: null,
  boxExampleStatus: {},
  audienceTiktok: null
};

export function profileReducer(state = initialState, action: ProfileAction.ProfileActions) {
  switch (action.type) {
    case ProfileAction.CLEAR_CHATS:
      return initialState;
    case ProfileAction.SET_CHARTS_RELOAD:
      return {
        ...state,
        chartReload: action.payload
      };
    case ProfileAction.SET_AUDIT:
      return {
        ...state,
        audit: action.payload
      };
    case ProfileAction.SET_AUDITS:
      return {
        ...state,
        audits: action.payload
      };
    case ProfileAction.SET_AUDIENCE_STAT:
      return {
        ...state,
        audienceStat: action.payload
      };
    case ProfileAction.SET_FOLLOWER_STAT:
      return {
        ...state,
        followerStat: action.payload
      };
    case ProfileAction.SET_MEDIA_STAT:
      return {
        ...state,
        mediaStat: action.payload
      };
    case ProfileAction.SET_AUDIENCE_INTEREST:
      return {
        ...state,
        audienceInterest: action.payload
      };
    case ProfileAction.SET_AUDIENCE_LOCATION:
      return {
        ...state,
        audienceLocation: action.payload
      };
    case ProfileAction.SET_MEDIA_ANALYZE:
      return {
        ...state,
        mediaAnalyze: action.payload
      };
    case ProfileAction.SET_MEDIA_COMMENT_ANALYZE:
      return {
        ...state,
        mediaCommentAnalyze: action.payload
      };
    case ProfileAction.SET_PROFILE_DETAIL:
      return {
        ...state,
        profileDetail: action.payload
      };
    case ProfileAction.SET_PROFILE_PROGRESS:
      return {
        ...state,
        profileProgress: action.payload
      };
    case ProfileAction.SET_FOLLOWER_ENGAGE:
      return {
        ...state,
        followerEngage: action.payload
      };
    case ProfileAction.SET_FOLLOWER_ENGAGE_INDICATOR:
      return {
        ...state,
        followerEngageIndicator: action.payload
      };
    case ProfileAction.SET_LOADER:
      const loader = state.loader;
      loader[action.payload.module][action.payload.box] = action.payload.value;
      return {
        ...state,
        loader: loader
      };
    case ProfileAction.SET_AUTOLOAD:
      return {
        ...state,
        autoload: action.payload
      };
    case ProfileAction.SET_PROFILE_MEDIA:
      return {
        ...state,
        profileMedia: action.payload
      };
    case ProfileAction.SET_PROFILE_SCORE:
      return {
        ...state,
        score: action.payload
      };
    case ProfileAction.SET_AUDIT_BOX_EXAMPLE_STATUS:
      const exampleBoxStatus = state.boxExampleStatus;
      exampleBoxStatus[action.payload.boxName] = action.payload.status;
      return {
        ...state,
        boxExampleStatus: exampleBoxStatus
      };
    case ProfileAction.SET_AUDIT_ID:
      return {
        ...state,
        auditId: action.payload.id
      };
    case ProfileAction.RESET_AUDIT_ID:
      return {
        ...state,
        auditId: 0
      };
    case ProfileAction.SET_USERS_RANK:
      return {
        ...state,
        userRank: action.payload
      };
    case ProfileAction.SET_PROFILE_AUDIENCE_TIKTOK:
      return {
        ...state,
        audienceTiktok: action.payload
      };
  }
  return state;
}

